import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { ErrorState } from './ErrorState';

interface ModulePageHeaderProps {
  title: string;
  subtitle: React.ReactNode;
  icon: LucideIcon;
  rightContent?: React.ReactNode;
}

export const ModulePageHeader: React.FC<ModulePageHeaderProps> = ({
  title,
  subtitle,
  icon: Icon,
  rightContent,
}) => {
  return (
    <header className="enterprise-module-header">
      <div className="min-w-0 flex-1">
        <div className="enterprise-module-header-title min-w-0">
          <Icon size={14} strokeWidth={1.75} className="shrink-0 enterprise-text-secondary" />
          <h1 className="truncate">{title}</h1>
        </div>
        <p className="enterprise-module-header-meta truncate">{subtitle}</p>
      </div>
      {rightContent && <div className="shrink-0 [&>*]:h-[var(--button-height)]">{rightContent}</div>}
    </header>
  );
};

export const ModuleCard: React.FC<{
  title: string;
  children: React.ReactNode;
  action?: React.ReactNode;
}> = ({ title, children, action }) => {
  return (
    <section className="enterprise-card-surface p-[var(--card-padding)]">
      <div className="mb-3 flex items-center justify-between gap-3 border-b border-enterprise-border-soft pb-2">
        <h2 className="enterprise-tech-label">{title}</h2>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      {children}
    </section>
  );
};

export const ModuleLoadingState: React.FC<{ label?: string }> = ({ label = 'Carregando dados' }) => (
  <div className="enterprise-card-surface p-[var(--card-padding)]">
    <div className="flex items-center gap-3 text-sm enterprise-text-secondary">
      <span className="h-4 w-4 rounded-full border-2 border-enterprise-border-strong border-t-enterprise-primary animate-spin" />
      <span>{label}...</span>
    </div>
  </div>
);

export const ModuleErrorState: React.FC<{ message: string; retry?: () => void }> = ({ message, retry }) => (
  <ErrorState message={message} onRetry={retry} />
);
